"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textColors = exports.colors = void 0;
var colors = ["primary", "accent", "success", "danger", "warning"];
exports.colors = colors;
var textColors = ["default", "hint", "inverted"].concat(colors);
exports.textColors = textColors;